export const fmtTime = (ts) => {
  if (!ts) return "—";
  return new Date(ts * 1000).toLocaleTimeString("en-US", { hour:"2-digit", minute:"2-digit", second:"2-digit" });
};
export const fmtDate = (ts) => {
  if (!ts) return "—";
  return new Date(ts * 1000).toLocaleDateString("en-US", { month:"short", day:"numeric", hour:"2-digit", minute:"2-digit" });
};
export const pct = (val, max) => (max ? Math.round((val / max) * 100) : 0);
export const short = (s, n = 38) => s && s.length > n ? s.slice(0, n) + "…" : s || "";
export const isZoomUrl = (url) => /zoom\.us\/j\/\d+/.test(url||"") || /^\d{9,11}$/.test((url||"").trim());
export const progressColor = (p) => p >= 90 ? "red" : p >= 70 ? "amber" : "";
